export default function Edit({ className }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' className={ cn('h-6 w-6', className) } viewBox='0 0 24 24' stroke='currentColor'>
      <path d='M5.15 19H6.4L15.65 9.75L14.425 8.5L5.15 17.775ZM18.85 8.65 15.475 5.3 16.8 4Q17.225 3.575 17.863 3.575Q18.5 3.575 18.925 4L20.15 5.225Q20.575 5.675 20.6 6.287Q20.625 6.9 20.175 7.325ZM4.55 20.5Q4.175 20.5 3.913 20.238Q3.65 19.975 3.65 19.6V17.5Q3.65 17.325 3.713 17.163Q3.775 17 3.925 16.85L14.4 6.375L17.775 9.75L7.3 20.225Q7.15 20.375 6.988 20.438Q6.825 20.5 6.65 20.5ZM15.025 9.125 14.425 8.5 15.65 9.75Z'/></svg>
  )
}
